

import { defineComponent } from 'vue';

import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';


export default defineComponent({
  components: { ModalHeader, ModalBody},
  props: {
    imagePath: {},
  },
  data() {
    return {
        modal: null
    };
  },
  setup() {
    const store = useStore();
    return {
        store
    };
  },
  mounted() {
    const modalElement = this.$refs.imageViewer;
    this.modal = ModalService.initialize(modalElement, this);
    ModalService.size(modalElement, "lg");
    ModalService.open(this.modal);
  },
  methods: {
  }
});
